export default function debounce(callback, waitTime) {
  let timeout

  return function(...args) {
    const context = this
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      callback.apply(context, args)
    }, waitTime)
  }
}
